import { redirect } from 'react-router-dom';
import { PATHS } from 'src/types/Paths.ts';

export const checkLocalState = (target: string = PATHS.Home) => {
    const { state } = window.history;
    if (state === null || !('usr' in state)) {
        return redirect(target);
    }
    return 'ok';
};
